import React, { useState } from "react";
import { Box, Button, Typography, TextField } from "@mui/material";
import List from "./List"; // Make sure to import your List component

const PasswordProtectedList = () => {
  const [password, setPassword] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (password === process.env.REACT_APP_KEYWORD) {
      setIsAuthenticated(true);
      setError("");
    } else {
      setError("Incorrect password. Please try again.");
    }
  };

  return (
    <Box padding="1rem">
      {isAuthenticated ? (
        <List />
      ) : (
        <Box display="flex" flexDirection="column" width="300px" gap="10px" margin="24px 0px">
          <TextField label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <Button variant="primary" onClick={handleSubmit}>
            <Typography fontSize="16px" fontFamily={"NeurialGrotesk-Regular"}>
              Suivant
            </Typography>
          </Button>
          {error && (
            <Typography color="error" fontSize="14px" fontFamily={"NeurialGrotesk-Regular"}>
              {error}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default PasswordProtectedList;
